import { APP_LS_NAMESPACE_ID, APPLICANT } from "src/constants";
import { CARDS, VISA_PLATINUM_CREDIT_CARD } from "src/features/LoansHome/Products/constants";
import { STATUS_APPROVED, STATUS_UNDER_REVIEW, STATUS_SUBMITTED_FOR_ORDER, STATUS_COMPLETED, STATUS_INVITATION_SENT, STATUS_DECLINED, STATUS_ARCHIVED, STATUS_APPLICATION_STARTED, STATUS_WITHDRAW } from "src/services/constants";
import { USER_ONBOARD_ADMIN } from "src/services/constants/accounts";

const mkCreditCardApplicantStage = [
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    }
                ]
            }
        ],
        "name": STATUS_UNDER_REVIEW,
        "display_name": STATUS_UNDER_REVIEW
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_SUBMITTED_FOR_ORDER,
                        "display_name": STATUS_SUBMITTED_FOR_ORDER
                    }
                ]
            }
        ],
        "name": STATUS_APPROVED,
        "display_name": STATUS_APPROVED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_COMPLETED,
                        "display_name": STATUS_COMPLETED
                    }
                ]
            }
        ],
        "name": STATUS_SUBMITTED_FOR_ORDER,
        "display_name": STATUS_SUBMITTED_FOR_ORDER
    },
    {
        "children": [
            {
                "stages": []
            }
        ],
        "name": STATUS_COMPLETED,
        "display_name": STATUS_COMPLETED
    }
]
const mkCardStageforAdmin = [
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_INVITATION_SENT,
                        "display_name": STATUS_INVITATION_SENT
                    },
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_UNDER_REVIEW,
                        "display_name": STATUS_UNDER_REVIEW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_COMPLETED,
                        "display_name": STATUS_COMPLETED
                    },
                    {
                        "name": STATUS_ARCHIVED,
                        "display_name": STATUS_ARCHIVED
                    }
                ]
            }
        ],
        "name": STATUS_APPLICATION_STARTED,
        "display_name": STATUS_APPLICATION_STARTED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_UNDER_REVIEW,
                        "display_name": STATUS_UNDER_REVIEW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_ARCHIVED,
                        "display_name": STATUS_ARCHIVED
                    },
                    {
                        "name": STATUS_SUBMITTED_FOR_ORDER,
                        "display_name": STATUS_SUBMITTED_FOR_ORDER
                    },
                    {
                        "name": STATUS_COMPLETED,
                        "display_name": STATUS_COMPLETED
                    }
                ]
            }
        ],
        "name": STATUS_INVITATION_SENT,
        "display_name": STATUS_INVITATION_SENT
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_ARCHIVED,
                        "display_name": STATUS_ARCHIVED
                    },
                    {
                        "name": STATUS_COMPLETED,
                        "display_name": STATUS_COMPLETED
                    }
                ]
            }
        ],
        "name": STATUS_APPROVED,
        "display_name": STATUS_APPROVED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_SUBMITTED_FOR_ORDER,
                        "display_name": STATUS_SUBMITTED_FOR_ORDER
                    },
                    {
                        "name": STATUS_COMPLETED,
                        "display_name": STATUS_COMPLETED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_ARCHIVED,
                        "display_name": STATUS_ARCHIVED
                    }
                ]
            }
        ],
        "name": STATUS_UNDER_REVIEW,
        "display_name": STATUS_UNDER_REVIEW
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_SUBMITTED_FOR_ORDER,
                        "display_name": STATUS_SUBMITTED_FOR_ORDER
                    },
                    {
                        "name": STATUS_COMPLETED,
                        "display_name": STATUS_COMPLETED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_ARCHIVED,
                        "display_name": STATUS_ARCHIVED
                    }
                ]
            }
        ],
        "name": STATUS_DECLINED,
        "display_name": STATUS_DECLINED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_SUBMITTED_FOR_ORDER,
                        "display_name": STATUS_SUBMITTED_FOR_ORDER
                    },
                    {
                        "name": STATUS_COMPLETED,
                        "display_name": STATUS_COMPLETED
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    }
                ]
            }
        ],
        "name": STATUS_COMPLETED,
        "display_name": STATUS_COMPLETED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPLICATION_STARTED,
                        "display_name": STATUS_APPLICATION_STARTED
                    },
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_SUBMITTED_FOR_ORDER,
                        "display_name": STATUS_SUBMITTED_FOR_ORDER
                    },
                    {
                        "name": STATUS_COMPLETED,
                        "display_name": STATUS_COMPLETED
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    }
                ]
            }
        ],
        "name": STATUS_ARCHIVED,
        "display_name": STATUS_ARCHIVED
    },
    {
        "children": [
            {
                "stages": []
            }
        ],
        "name": STATUS_WITHDRAW,
        "display_name": STATUS_WITHDRAW
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_COMPLETED,
                        "display_name": STATUS_COMPLETED
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_ARCHIVED,
                        "display_name": STATUS_ARCHIVED
                    }
                ]
            }
        ],
        "name": STATUS_SUBMITTED_FOR_ORDER,
        "display_name": STATUS_SUBMITTED_FOR_ORDER
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_SUBMITTED_FOR_ORDER,
                        "display_name": STATUS_SUBMITTED_FOR_ORDER
                    },
                    {
                        "name": STATUS_COMPLETED,
                        "display_name": STATUS_COMPLETED
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    }
                ]
            }
        ],
        "name": STATUS_COMPLETED,
        "display_name": STATUS_COMPLETED
    }
]

const APPLS_CARDS_STAGES_CONFIG = {
    id: '154878745215745754',
    namespace_id: APP_LS_NAMESPACE_ID,
    loan_type: [CARDS],
    sub_loan_types: [VISA_PLATINUM_CREDIT_CARD],
    stages: mkCardStageforAdmin,
    roles: [USER_ONBOARD_ADMIN],
};

const APPLS_CARD_STAGES_CONFIG_APPLICANT = {
    id: '154878745215745754',
    namespace_id: APP_LS_NAMESPACE_ID,
    loan_type: [CARDS],
    sub_loan_types: [VISA_PLATINUM_CREDIT_CARD],
    stages: mkCreditCardApplicantStage,
    roles: [APPLICANT],
};



export const cardsStages = [
    APPLS_CARDS_STAGES_CONFIG,
    APPLS_CARD_STAGES_CONFIG_APPLICANT
]